import { Link } from "react-router-dom";
import styled from "styled-components";

import FlexBox from "../components/common/FlexBox";
import { H2 } from "../components/common/Headings";
import { MOSS_GREEN_800 } from "../components/common/colors";

const Container = styled(FlexBox)`
  flex-direction: column;
  padding: 1.5rem;
  row-gap: 0.5rem;
`;

const StyledLink = styled(Link)`
  color: ${MOSS_GREEN_800};
`;

const PageNotFound = ({ link, title }) => {
  return (
    <Container>
      <H2 bold>Error 404: Page not found</H2>
      <StyledLink to={link}>Go to {title}</StyledLink>
    </Container>
  );
};

export default PageNotFound;
